export const siteConfig = {
    name: 'Automação Containers',
    description: 'Buckler — interface v2',
    logo: '/img/design/Logo_Buckler_Oldblack.png',
    logoDark: '/img/design/Logo_Buckler_OffWhite.png',
};
